<template>
  <div>
    <div class="box info-box">
      <div class="box-header with-border">
          <h3 class="box-title">Recent Paid EMIs</h3>

          <!-- <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
          </button>
          <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div> -->
      </div>
      <!-- /.box-header -->
      <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Loan ID</th>
                <th>Cust Name</th>
                <!-- <th class="hidden-xs">Cust Code</th> -->
                <th class="hidden-xs">Pay Date</th>
                <th>Amount</th>
                <th class="hidden-xs">Received</th>
                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rowsMemberCollections.data" :key="index">
                <td class="hidden-xs">{{ index + 1 }}</td>
                <td> <span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                <td> <span v-if="row.member">{{ row.member.name }}</span></td>
                <!-- <td> <span v-if="row.member" class="hidden-xs">{{ row.member.code }}</span></td> -->
                <td class="hidden-xs">{{ row.paymentDate }}</td>
                <td>{{ row.amt }} <small v-if="row.type === 'panulty'">(penalty)</small><small v-else>({{row.type}})</small></td>
                <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.name }}</span></td>
              </tr>
            </tbody>
          </table>
                
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recentcollection',
  data () {
    return {
      isLoading: false,
      editMode: false,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: 'paymentDate',
          type: 'date'
        },
        page: 1,
        perPage: 10
      },
      rowsMemberCollections: []
    }
  },
  methods: {
    getSingleMemberLoanDetails () {
      if (JSON.parse(localStorage.user).type === 'member') {
        this.$axios
        .get('membercollection?per_page=5&status=approved&member_id=' + JSON.parse(localStorage.user).id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (JSON.parse(localStorage.user).type === 'staff') {
        this.$axios
        .get('membercollection?per_page=5&status=approved&receivedBy=' + JSON.parse(localStorage.user).id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (JSON.parse(localStorage.user).type === 'admin') {
        this.$axios
        .get('membercollection?per_page=5&status=approved', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    }
  },
  created () {
    this.getSingleMemberLoanDetails()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// recentcollection.vue?e8853284